export const BusJsonDataEnum = {
  ANGLE: 'angle',
  DELAY: 'delay',
  DESTINATION_NAME: 'destinationName',
  LAST_STOP: 'lastStop',
  LATITUDE: 'latitude',
  LINK_NUMBER: 'linkNumber',
  LINK_NUMBER_ALIAS:'linkNumberAlias',
  LONGITUDE: 'longitude',
  MAIN_TYPE: 'mainType',
  SPZ: 'spz',
  STATE:'state',
  TYPE: 'type',
  UPDATED: 'updated'
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/BusJsonDataEnum.js